import {
    module
} from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        [...document.querySelectorAll('.c-button__zoom, .c-overlay-product__close')].forEach(el => {
            el.addEventListener('click', () => {
                [...document.querySelectorAll('.c-overlay-product .c-overlay-product-figure_img')].forEach(el2 => {
                    el2.src = document.querySelector('.swiper-slide-active img').src;
                });
                document.querySelector('html').classList.toggle('has-overlay-product-open');
            });
        });
    }
}